import axios from "axios";

export const GET_BECAS_LIST    = "GET_BECAS_LIST";

export const getBecasList = () => {

    return (dispatch) => {
        //console.log("Javier -------> Se carga ACTION | getBecasList");
        axios
            .get("/api/ReporteAdministrativo/ObtieneBecas")
            .then(function (response) {
                //console.log(response.data);
                dispatch({
                    type: GET_BECAS_LIST,
                    payload: {
                        data: response.data,
                        errorMessage: false,
                    },
                });

            })
            .catch(function (error) {
                dispatch({
                    type: GET_BECAS_LIST,
                    payload: {
                        data: false,
                        errorMessage: error.message,
                    },
                });
            });
    };
};

